<style type="text/css">
  .m-body .m-content {
    padding-bottom: 0;
  }

  #messages_container {
    overflow-y: scroll;
    max-height: 860px;
  }

  .support_message {
    margin-top: 15px;
    width: 60%;
  }

  .support_message.from_admin {
    margin-left: 40%;
  }

  .support_message.from_user span.message_time {
    display: block;
    text-align: right;
  }

  .support_message.from_admin span.message_time {
    display: block;
    text-align: left;
  }

  .support_message .user_logo {
    float: left;
    overflow: hidden;
    border-radius: 50%;
    background: white;
  }

  .support_message.from_admin .user_logo {
    float: right;
    margin-right: 15px;
  }

  .support_message .user_logo img {
    width: 50px;
    height: 50px;
  }

  .support_message .message_content {
    position: relative;
    width: calc(100% - 75px);
    display: inline-block;
    margin-left: 25px;
    background: white;
    padding: 10px;
    border-radius: 0px 10px 10px 10px;
  }

  .support_message.from_admin .message_content {
    width: calc(100% - 90px);
    border: 0;
    border-radius: 10px 0px 10px 10px;
    float: right;
    margin: 0;
    margin-right: 25px;
    background: #48a6a6;
    color: white;
  }

  .support_message .message_content:before {
    content: "";
    position: absolute;
    height: 0;
    width: 0;
    right: 100%;
    top: 0;
    border: 15px solid transparent;
  }

  .support_message.from_user .message_content:before {
    border-right: 0 solid white;
    border-top: 20px solid white;
  }

  .support_message.from_admin .message_content:before {
    right: 0;
    left: 100%;
    border-left: 0 solid #22b9ff;
    border-top: 20px solid #22b9ff;
  }

  .support_message .message_content ul {
    margin: 0;
    padding: 0;
  }

  .support_message .message_content ul li {
    width: 25%;
    float: left;
    text-align: center;
    display: inline-block;
  }

  .support_message .message_content img,
  .support_message .message_content iframe {
    width: 200px !important;
    height: 200px !important;
  }

  .support_message .message_content ul li a {
    text-decoration: none;
    color: #0091d5;
    font-weight: 500;
  }

  .support_message.from_admin .message_content ul li a {
    color: white;
  }

  .support_message .message_content ul li a .attachment_icon {
    padding: 10px;
  }

  .support_message .message_content ul li a .attachment_icon i {
    font-size: 66px;
    color: #0091d5;
  }

  .support_message.from_admin .message_content ul li a .attachment_icon i {
    color: white;
  }

  .support_message .message_content ul li a span {
    width: 80px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
  }

  .support_message .message_content a:hover {
    color: #2739c1;
  }

  .support_message.from_admin .message_content a {
    color: black;
  }

  /* width */
  #messages_container::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  #messages_container::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  #messages_container::-webkit-scrollbar-thumb {
    background: #22b9ff;
  }

  /* Handle on hover */
  #messages_container::-webkit-scrollbar-thumb:hover {
    background: #43b3e7;
  }

  textarea {
    resize: vertical;
  }

  .dropzone {
    border: 2px solid #22b9ff;
  }

  select.form-control {
    padding: 0;
    padding-left: 10px;
  }
</style>
<template>
  <div class="new_ticket">
    <form class="forms-sample" style="margin-bottom: 0; border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
      <h6 class="sub-title mb-3 font-weight-bold color-default" style="border: 0; margin: 0 !important; padding: 0">
        {{ formHeader }}
      </h6>
    </form>

    <form class="forms-sample" :key="this.$route.params.ticket" style="margin-top: 0">
      <div class="form-group row">
        <div id="messages_container" class="col-md-7">
          <div class="row" v-for="(tm, index) in ticket.messages" :key="index">
            <div v-bind:class="{
                support_message: 1,
                from_admin: tm.sent_by_admin == 1,
                from_user: tm.sent_by_admin == 0,
              }">
              <span class="message_time">{{
                tm.created_at | formatDateTime
                }}</span>
              <div class="user_logo">
                <img v-if="tm.sent_by_admin == 1" :src="main_site_url + 'images/logo.png'" alt="Logo" />
                <img v-else :src="main_site_url + '/uploads/profile/' + user_logo" alt="Logo" />
              </div>
              <div class="message_content">
                <p v-html="tm.message"></p>
                <div v-if="tm.attachments.length">
                  <hr />
                  <ul>
                    <li v-for="(tma, index) in tm.attachments" :key="index">
                      <a :href="
                          main_site_url +
                          '/uploads/support/' +
                          ticket.organization_id +
                          '/' +
                          tma.path
                        " target="_blank" :title="tma.name">
                        <font-awesome-icon :icon="['fas', 'file-image']" size="3x" v-if="
                            supportedImageFormats.includes(
                              tma.name.substr(tma.name.lastIndexOf('.'))
                            )
                          " />
                        <font-awesome-icon :icon="['fas', 'file-word']" size="3x" v-else-if="
                            supportedDocumentFormats.includes(
                              tma.name.substr(tma.name.lastIndexOf('.'))
                            )
                          " />
                        <font-awesome-icon :icon="['fas', 'file-video']" size="3x" v-else-if="
                            supportedVideoFormats.includes(
                              tma.name.substr(tma.name.lastIndexOf('.'))
                            )
                          " />
                        <font-awesome-icon :icon="['fas', 'file-audio']" size="3x" v-else-if="
                            supportedAudioFormats.includes(
                              tma.name.substr(tma.name.lastIndexOf('.'))
                            )
                          " />
                        <font-awesome-icon :icon="['fas', 'tag']" size="3x" v-else />
                        <span>{{ tma.name }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div id="messages_container_end"></div>
        </div>
        <div class="col-md-5" style="border-left: 1px solid rgba(0, 0, 0, 0.1)">
          <div class="col-md-12">
            <label class="label-form" for="message">Delivery Date:</label>
            <input id="delivery_date" type="date" v-model="ticket_delivery_date" class="form-control"
              format="MM/dd/yyyy" @blur="changeTicketDeliveryDate" :min="min_date" />
          </div>
          <div class="col-md-12">
            <label class="label-form" for="message">Status:</label>
            <select id="status" class="form-control" @change="changeTicketStatus">
              <option v-if="ticket.status == 0" value="0" selected>Open</option>
              <option v-else value="0">Open</option>
              <option v-if="ticket.status == 1" value="1" selected>
                In Progress
              </option>
              <option v-else value="1">In Progress</option>
              <!-- <option v-if="ticket.status == 2" value="2" selected>
                Dead Leads
              </option> -->
              <!-- <option v-else value="2">Dead Leads</option> -->
              <option v-if="ticket.status == 10" value="10" selected>
                Closed
              </option>
              <option v-else value="10">Closed</option>
            </select>
          </div>
          <div class="col-md-12" style="margin-top: 20px">
            <input type="checkbox" v-model="ticketForm.customer_feedback" />
            <span class="checkmark"></span>
            Customer Feedback
          </div>
          <hr />
          <!-- title input -->
          <div class="col-md-12" v-if="ticket.status != 10">
            <label class="label-form" for="message">Message:</label>
            <tiny-mce-editor :vModelName.sync="ticketForm.message"></tiny-mce-editor>
            <!-- <textarea id="message" v-model="ticketForm.message" placeholder="Message" class="form-control"></textarea> -->
          </div>
          <br />
          <!-- caption input -->
          <div class="col-md-12" v-if="ticket.status != 10">
            <vue-dropzone ref="myVueDropzone" id="dropAttach" :options="dropzoneOptions"></vue-dropzone>
          </div>
        </div>
      </div>
      <div class="text-right" v-if="ticket.status != 10">
        <button class="btn btn-primary" @click.prevent="save">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from "axios";
  import "jodit/build/jodit.min.css";
  import JoditVue from "jodit-vue";
  import TinymceEditor from "../../views/partials/tiny_mce_editor";

  import moment from "moment";
  import vue2Dropzone from "vue2-dropzone";
  import "vue2-dropzone/dist/vue2Dropzone.min.css";

  Vue.filter("formatDateTime", function (value) {
    if (value) {
      return (
        moment(String(value)).format("DD MMMM, YYYY") +
        " at " +
        moment(String(value)).format("hh:mm:ss A")
      );
    }
  });

  export default {
    components: {
      JoditVue,
      vueDropzone: vue2Dropzone,
      "tiny-mce-editor": TinymceEditor,
    },

    data: function () {
      var supportedImageFormats = [
        ".jpeg",
        ".jfif",
        ".tiff",
        ".bmp",
        ".jpg",
        ".png",
        ".gif",
      ];
      var supportedDocumentFormats = [
        ".docx",
        ".rtf",
        ".doc",
        ".pdf",
        ".txt",
        ".xls",
        ".xlsx",
      ];
      var supportedVideoFormats = [".mp4", ".avi", ".flv", ".wmv", ".mov"];
      var supportedAudioFormats = [".mp3", ".wav", ".aac"];
      var unique_folder = Math.floor(Math.random() * 90000) + 10000;

      return {
        formHeader: "",
        user_logo: "",
        ticket: "",
        main_site_url: process.env.VUE_APP_LINENTECH_V3,
        ticketForm: {},
        ticket_delivery_date: "",
        supportedImageFormats: supportedImageFormats,
        supportedDocumentFormats: supportedDocumentFormats,
        supportedVideoFormats: supportedVideoFormats,
        supportedAudioFormats: supportedAudioFormats,
        unique_folder: unique_folder,
        min_date: "",
        buttons: [
          "bold",
          "strikethrough",
          "underline",
          "italic",
          "|",
          "ul",
          "ol",
          "|",
          "image",
          "table",
          "link",
          "|",
          "outdent",
          "indent",
          "|",
          "align",
          "undo",
          "redo",
          "|",
          "hr",
          "symbol",
          "fullsize",
        ],
        config: {
          uploader: {
            insertImageAsBase64URI: true,
          },
        },
        dropzoneOptions: {
          url: process.env.VUE_APP_LINENTECH_V3 + "/upload", // This is broken link which is not going to upload image.
          maxFilesize: 10,
          acceptedFiles:
            supportedImageFormats.join(", ") +
            "," +
            supportedDocumentFormats.join(", ") +
            "," +
            supportedVideoFormats.join(", ") +
            "," +
            supportedAudioFormats.join(", "),
          addRemoveLinks: true,
          timeout: 50000,
          success: function (file, response, xhr) { },
          error: function (file, response, xhr) {
            if (response == "You can't upload files of this type.") {
              var fileRef;
              (fileRef = file.previewElement) != null
                ? fileRef.parentNode.removeChild(file.previewElement)
                : void 0;
              alert(
                response +
                "\n" +
                "Here is the list of supported files:" +
                "\n" +
                "Support image formats: " +
                supportedImageFormats.join(", ") +
                "\n" +
                "Support document formats: " +
                supportedDocumentFormats.join(", ") +
                "\n" +
                "Support audio formats: " +
                supportedAudioFormats.join(", ") +
                "\n" +
                "Support video formats: " +
                supportedVideoFormats.join(", ") +
                "\n"
              );
            }
            return false;
          },
        },
      };
    },

    computed: {
      // ticket: function () {
      //   return this.$store.getters['support/ticket'];
      // },
    },
    created: function () {
      // new form
      if (typeof this.$route.params.ticket === "undefined") {
        return;
      }
      this.ticketForm = {
        id: this.$route.params.ticket,
        org_id: this.$route.params.org_id,
        customer_feedback: false,
        message: "",
        attachment: [],
      };
      // update from
      let loader = this.$loading.show({
        loader: "dots",
      });
      this.formHeader = "";
      this.user_logo = "";
      this.$store
        .dispatch("support/getSuportTicket", [
          this.ticketForm.id,
          this.ticketForm.org_id,
        ])
        .then(() => {
          this.ticket = this.$store.getters["support/supportTicket"];
          let user_logo = this.$store.getters["support/user_logo"];
          this.formHeader = this.ticket.title;
          this.user_logo = user_logo;
          this.$gate.setUnreadTicketsCount();
          if (this.ticket.delivery_date) {
            this.ticket_delivery_date = moment(
              String(this.ticket.delivery_date)
            ).format("YYYY-MM-DD");
          }
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
          this.$toast.error(err);
        });
    },
    mounted() {
      this.formatDate();
    },
    methods: {
      formatDate() {
        var d = new Date(),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        this.min_date = [year, month, day].join("-");
      },
      save() {
        // add the div.body-wrapper when update or create new post
        if (
          this.ticketForm.message == "" ||
          this.ticketForm.message.length <= 61
        ) {
          this.$toast.warning(`Message can not be empty.`);

          return;
        }
        this.sendReply(this.ticketForm);
      },

      // Send Reply to ticket
      sendReply(ticket) {
        let loader = this.$loading.show({
          loader: "dots",
        });
        ticket["org_id"] = this.ticket.organization_id;
        ticket["user_id"] = this.ticket.user_id;
        this.ticketForm.attachment = this.$refs.myVueDropzone.getAcceptedFiles();
        this.$store
          .dispatch("support/sendReply", ticket)
          .then((data) => {
            loader.hide();
            // send successful message
           this.$toast.success(`Message has been sent successfully`);

            this.$router.push("/support");
          })
          .catch((error) => {
            loader.hide();
            let response = error.response;
            // send error message
           this.$toast.error(`OOPS! something went wrong`);
            this.$router.push("/support");
          });
      },
      // change ticket status
      changeTicketStatus() {
        this.$store
          .dispatch("support/changeTicketStatus", {
            ticket_id: this.ticketForm.id,
            status: $("#status").val(),
          })
          .then((data) => {
            // send successful message
           this.$toast.success(`Ticket status has been updated successfully`);
          })
          .catch((error) => {
            let response = error.response;

            // send error message
           this.$toast.error(`OOPS! something went wrong`);
          });
      },

      // change ticket delivery date
      changeTicketDeliveryDate() {
        if (
          $("#delivery_date").val() != "" &&
          (!this.ticket.delivery_date ||
            $("#delivery_date").val() !=
            moment(String(this.ticket.delivery_date)).format("YYYY-MM-DD"))
        ) {
          this.ticket.delivery_date = $("#delivery_date").val();
          this.$store
            .dispatch("support/changeTicketDeliveryDate", {
              ticket_id: this.ticketForm.id,
              delivery_date: $("#delivery_date").val(),
            })
            .then((data) => {
              // send successful message
             this.$toast.success(`Ticket delivery date has been updated successfully`);
            })
            .catch((error) => {
              let response = error.response;

              // send error message
             this.$toast.error(`OOPS! something went wrong`);
            });
        }
      },
    },
  };
</script>